import {useCallback, useMemo, useState} from 'react';
import {createListParams, ListParams, SetListParamsOptions, UseListParamsReturn} from './listParams';

export const useListParamsState = (initial: Partial<ListParams> = {}): UseListParamsReturn => {
    const initialParams = useMemo(() => createListParams(initial), [initial]);

    const [listParams, setListParamsState] = useState<ListParams>(initialParams);

    const setListParams = useCallback(
        (partial: Partial<ListParams>, options: SetListParamsOptions = {}) => {
            setListParamsState((prev) => {
                const next: ListParams = {...prev, ...partial};

                if (options.resetPage) {
                    next.page = initialParams.page;
                }

                return next;
            });
        },
        [initialParams.page]
    );

    return {
        listParams,
        setListParams,
    };
};
